import React, { useId } from 'react';

interface GradientBorderProps {
  radius: number;
  colors: string[];
  width?: number;
  stops?: number[];
  className?: string;
}

function GradientBorder({
  radius,
  colors,
  width = 1,
  stops,
  className,
}: Readonly<GradientBorderProps>): React.ReactElement {
  const gradientId = useId();
  const offsets =
    stops ??
    colors.map((_, i) => (colors.length === 1 ? 0 : i / (colors.length - 1)));

  return (
    <svg
      aria-hidden="true"
      width="100%"
      height="100%"
      className={className}
      style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }}
    >
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
          {colors.map((color, i) => (
            <stop key={`${gradientId}-${i}`} offset={offsets[i]} stopColor={color} />
          ))}
        </linearGradient>
      </defs>
      <rect
        x="0"
        y="0"
        width="100%"
        height="100%"
        rx={radius}
        ry={radius}
        fill="none"
        stroke={`url(#${gradientId})`}
        strokeWidth={width * 2}
      />
    </svg>
  );
}

export default GradientBorder;
